import { useHistory } from 'react-router-dom';
import { memo, useState, useCallback, useEffect, useMemo } from 'react';

import Card from '../../../../common/card';
import { PROFILE_CREATION_PATH } from '../../../../routes/paths';
import { nortadaStorage } from '../../../../../constants/helpers/storage';
import WithQriosBackground from '../../../../common/qrios-background/withQriosBackground';
import { NORTADA_NEW_CLIENT_PROFILE_STEP, OTP_PENALTY_TIME } from '../../../../../constants/storage';

import DialogContent from './dialogContent';
import { getBlockedInfo, getEnabledInfo } from './utils';

const ProfileCreationBlocked = () => {
  const { setInterval, clearInterval } = window;
  const history = useHistory();
  const [penaltyTime, setPenaltyTime] = useState<number>(nortadaStorage.getItem(OTP_PENALTY_TIME) || 0);
  const [intervalID, setIntervalID] = useState<number>(0);

  const isBlocked = useMemo(() => penaltyTime > 0, [penaltyTime]);

  const handleSubmit = useCallback(() => {
    nortadaStorage.setItem(NORTADA_NEW_CLIENT_PROFILE_STEP, 1);
    history.replace(PROFILE_CREATION_PATH.PROFILE_CREATION);
  }, [history]);

  const handleInterval = useCallback(() => {
    let time = penaltyTime;

    const id = setInterval(() => {
      time -= 1;

      setPenaltyTime(time);

      if (time === 0) {
        clearInterval(id);
      }
    }, 1000);

    setIntervalID(id);
  }, [clearInterval, penaltyTime, setInterval]);

  useEffect(() => {
    handleInterval();

    return () => clearInterval(intervalID);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dialogContent = isBlocked ? (
    <DialogContent
      title="Creating a new client profile failed"
      infoText={getBlockedInfo(penaltyTime)}
      submitHandler={handleSubmit}
      status="blocked"
    />
  ) : (
    <DialogContent
      title="Creating a new client profile"
      infoText={getEnabledInfo()}
      submitHandler={handleSubmit}
      status="enabled"
    />
  );

  return (
    <WithQriosBackground title="Get started with a free Qrios account">
      <Card content={dialogContent} />
    </WithQriosBackground>
  );
};

export default memo(ProfileCreationBlocked);
